export const translations = {
  en: {
    login: {
      addEmailAddressPrompt:
        'Please add your email address on file ending in {{email}}',
      addMobilePhoneNumberPrompt:
        'Please add your mobile phone number on file ending in {{phoneNumber}}',
      contactMethodPrompt:
        'In order to continue we need a contact method to send a code to. When you arrive for your appointment, please let the front desk know that you want to add a contact method.',
      continue: 'Continue',
      checking: 'Checking {{input}}...',
      doesNotMatch: 'Does not match, try again.',
      enterPatientDateOfBirthAndLastName: `Please enter the patient's date of birth and last name.`,
      errorLoggingIn: 'There was an error logging in.',
      informationNotMatchedEnterDOBLastNameZip: `The information you entered doesn't match our records. Please enter the patient's date of birth, last name, and zip code.`,
      incorrectZipCode: 'Incorrect zip code.',
      invalidZipSelected:
        'Invalid zip selected, please select/unselect the correct zip and try again.',
      lastNameAndDateOfBirthMustBeProvided:
        'Last name and date of birth must be provided.',
      linkExpiredCheckForNewerLink:
        'This link has expired. If your appointment has not already passed, please check your messages for a newer link.',
      linkNoLongerValid:
        'This link is no longer valid. If your appointment has not already passed, please check your messages for a newer link.',
      maxAttemptsReached: 'Max attempts reached',
      maxLoginAttemptsReachedCallClinicForHelp:
        'Max login attempts reached. Please call your clinic for help.',
      noContactMethodOnFile: 'No contact method on file.',
      patientDateOfBirth: 'Patient date of birth',
      patientLastName: 'Patient last name',
      resendCodeOption: "Didn't receive? Resend code",
      safeExitMessage: 'You may now safely exit this experience.',
      securityResideInWhichZIPCode:
        'For your security, in which of the following ZIP codes do you reside?',
      selectMethodToSendCode:
        'Please select the method for us to send you a 6-digit code so that we can verify your identity.',
      sendCode: 'Send code',
      sendViaEmail: 'Send via email',
      sendViaTextMessage: 'Send via text message',
      signIn: 'Sign in',
      sixDigitCodePrompt: 'Enter the 6-digit code.',
      sixDigitCodeSentPrompt:
        'We just sent you a 6-digit code. Add the code below to continue.',
      somethingWentWrongRefreshOrContactSupport:
        'Something went wrong. Please refresh or contact the practice for support.',
      thankYouForResponseNoFurtherAction:
        'Thank you for your response. No further action is needed. We look forward to your appointment.',
      verifyYourIdentity: 'Verify your identity',
      zipCode: 'Zip code',
    },
  },
  es: {
    login: {
      addEmailAddressPrompt:
        'Por favor, añade tu dirección de correo electrónico en el archivo que termina en {{email}}.',
      addMobilePhoneNumberPrompt:
        'Por favor, añade tu número de teléfono móvil en el archivo que termina en {{phoneNumber}}.',
      contactMethodPrompt:
        'Para continuar, necesitamos un método de contacto para enviar un código. Cuando llegues a tu cita, por favor, informa en la recepción que deseas añadir un método de contacto.',
      continue: 'Continuar',
      checking: 'Verificando {{input}}...',
      doesNotMatch: 'No coincide, inténtalo de nuevo.',
      enterPatientDateOfBirthAndLastName:
        'Por favor, ingrese la fecha de nacimiento y el apellido del paciente.',
      errorLoggingIn: 'Hubo un error al iniciar sesión.',
      informationNotMatchedEnterDOBLastNameZip:
        'La información que ingresó no coincide con nuestros registros. Por favor, ingrese la fecha de nacimiento, el apellido y el código postal del paciente.',
      incorrectZipCode: 'Código postal incorrecto.',
      invalidZipSelected:
        'El código postal seleccionado no es válido, seleccione / anule la selección del código postal correcto y vuelva a intentarlo.',
      lastNameAndDateOfBirthMustBeProvided:
        'Debe proporcionar el apellido y la fecha de nacimiento.',
      linkExpiredCheckForNewerLink:
        'Este enlace ha caducado. Si su cita aún no ha pasado, por favor, revise sus mensajes para obtener un enlace más nuevo.',
      linkNoLongerValid:
        'Este enlace ya no es válido. Si su cita aún no ha pasado, por favor, revise sus mensajes para obtener un enlace más nuevo.',
      maxLoginAttemptsReachedCallClinicForHelp:
        'Se han alcanzado el máximo de intentos de inicio de sesión. Por favor, llame a su clínica para obtener ayuda.',
      noContactMethodOnFile: 'No hay método de contacto registrado.',
      patientDateOfBirth: 'Fecha de nacimiento del paciente',
      patientLastName: 'Apellido del paciente',
      resendCodeOption: '¿No recibiste el código? Reenviar código',
      safeExitMessage:
        'Ahora puedes salir de esta experiencia de forma segura.',
      securityResideInWhichZIPCode:
        'Por su seguridad, ¿en cuál de los siguientes códigos postales reside?',
      selectMethodToSendCode:
        'Por favor, selecciona el método para que te enviemos un código de 6 dígitos y podamos verificar tu identidad.',
      sendCode: 'Enviar código',
      sendViaEmail: 'Enviar por correo electrónico',
      sendViaTextMessage: 'Enviar por mensaje de texto',
      signIn: 'Iniciar sesión',
      sixDigitCodePrompt: 'Ingresa el código de 6 dígitos.',
      sixDigitCodeSentPrompt:
        'Acabamos de enviarte un código de 6 dígitos. Ingresa el código a continuación para continuar.',
      somethingWentWrongRefreshOrContactSupport:
        'Algo salió mal. Por favor, actualice la página o póngase en contacto con la clínica para obtener ayuda.',
      thankYouForResponseNoFurtherAction:
        'Gracias por su respuesta. No es necesario tomar ninguna medida adicional. Esperamos su cita.',
      verifyYourIdentity: 'Verifica tu identidad',
      zipCode: 'Código postal',
    },
  },
  ru: {
    login: {
      continue: 'Продолжить',
    },
  },
  ht: {
    login: {
      continue: 'Kontinye',
    },
  },
  km: {
    login: {
      continue: 'បន្ត',
      enterPatientDateOfBirthAndLastName:
        'សូមវាយចូលថ្ងៃ ខែ ធ្នាំ កំណើតរបស់អ្នកជម្ងឺ',
      errorLoggingIn: 'មានការរអាក់រអួលក្នុងការចូល។',
      informationNotMatchedEnterDOBLastNameZip:
        'ព័ត៌មានដែលអ្នកបញ្ចូលមិនផ្គូផ្គងនិងសូមបញ្ចូលកាលបរិច្ឆេទខែឆ្នាំកំណើតនិងនាមត្រកូលភេតកូលបន្តកូដតំបន។',
      incorrectZipCode: 'លេខកូដចំណែកចូលមិនបន្ត',
      invalidZipSelected:
        'បានជ្រើសរើស​​/មិនបានជ្រើសរើស លើលេខកូដដំបន់ត្រឹមត្រូវ ហើយព្យាយាមម្ដងទៀត។',
      lastNameAndDateOfBirthMustBeProvided:
        'ត្រូវមាន នាមត្រកូល និងថ្ងៃខែធ្នាំកំណើត',
      linkExpiredCheckForNewerLink:
        'តំណនេះបានផុតកំណត់។ ប្រសិនបើការណាត់ជួបរបស់អ្នកមិនទាន់បានបញ្ចប់សូមពិនិត្យមើលសាររបស់អ្នកសម្រាប់តំណថ្មីមួយ។',
      linkNoLongerValid:
        'តំណើរយល់នេះមិនត្រឹមត្រូវទេ។ ប្រសិនបើនេះមិនទៅវិយ្តលទេសូមពិពណបញ្ជូនអ៊ីមែលរបស់អ្នកដើម្បីស្វែងរកតំណើរយល់ថ្មី។',
      maxLoginAttemptsReachedCallClinicForHelp:
        'ចំនួនរបស់ការចូលមិនឃើញការជូនដំណឹងសូមទូរសព័ររបស់អ្នកសមាជិកទូរសព័រកុំរុញផ្អែកផ្អែង។',
      patientDateOfBirth: 'ថ្ងៃខែ​ឆ្នាំ​កំណើត',
      patientLastName: 'នាមត្រកូល',
      securityResideInWhichZIPCode:
        'សំរាប់សន្តិសុខរបស់អ្នក តើលេខកូដតំបន់មួយណា ដែលអ្នករស់នៅ ?',
      signIn: 'ចុះហត្ថលេខា',
      somethingWentWrongRefreshOrContactSupport:
        'មាន​អ្វីមួយ​មិនត្រឹមត្រូវ សូមចុចសាឡើងវិញ ឬ ទាក់ទងទៅអ្នកធ្វើការសំរាប់ជំនួយ។',
      thankYouForResponseNoFurtherAction:
        'សូមអរគុណចំពោះការឆ្លើយតបរបស់អ្នក។ មិនមានសកម្មភាពបន្តទេ។ យើងរងចាំសំបុត្ររបស់អ្នក។',
      zipCode: 'លេខ​កូដ​តំបន់',
    },
  },
  pt: {
    login: {
      continue: 'Continuar',
      patientDateOfBirth: 'Data de nascimento do paciente',
      patientLastName: 'Sobrenome do paciente',
      signIn: 'Entrar',
      thankYouForResponseNoFurtherAction:
        'Obrigado pela sua resposta. Aguardamos suas próximas consultas.',
    },
  },
  bn: {
    login: {
      continue: 'চালিয়ে যান',
      patientDateOfBirth: 'রোগীর জন্ম তারিখ',
      patientLastName: 'রোগীর পদবি',
      signIn: 'সাইন ইন করুন',
      thankYouForResponseNoFurtherAction:
        'আপনার প্রতিক্রিয়ার জন্য আপনাকে ধন্যবাদ জানাই। আমরা আপনার আগামী অ্যাপয়েন্টমেন্টের অপেক্ষা করছি।',
    },
  },
  ja: {
    login: {
      continue: '続行',
      patientDateOfBirth: '患者の生年月日',
      patientLastName: '患者の姓',
      signIn: 'サインイン',
      thankYouForResponseNoFurtherAction:
        'ご回答ありがとうございます。お会いできることを楽しみにしております。',
    },
  },
  ko: {
    login: {
      continue: '계속',
      patientDateOfBirth: '환자 생년월일',
      patientLastName: '환자 성(姓)',
      signIn: '로그인',
      thankYouForResponseNoFurtherAction:
        '답변해 주셔서 감사합니다. 곧 예정된 예약에서 뵙겠습니다.',
    },
  },
  ro: {
    login: {
      continue: 'Continuare',
      patientDateOfBirth: 'Data nașterii pacientului',
      patientLastName: 'Numele pacientului',
      signIn: 'Accesați',
      thankYouForResponseNoFurtherAction:
        'Vă mulțumim pentru răspunsul dvs. Așteptăm cu nerăbdare programările dumneavoastră viitoare.',
    },
  },
  zh: {
    login: {
      continue: '继续',
      patientDateOfBirth: '患者出生日期',
      patientLastName: '患者姓氏',
      signIn: '登录',
      thankYouForResponseNoFurtherAction:
        '感谢您的回复。我们期待着您即将到来的预约。',
    },
  },
};
